import _kebabCase from 'lodash/kebabCase';

import { Pixall } from 'reaxl-analytics-handlers';

import { getInventoryOwnerById, isVDP } from '@/analytics/utilities';
/**
 * @summary Sends Pixall event when clicking on badge
 */
export function inventoryBadgeClick(metadata, option) {
    const { data = {}, dataLayer = {}, state } = metadata;
    const { labelText, inventoryId } = data;
    const inventory = getInventoryOwnerById(state, inventoryId);
    const isPrivateSeller = inventory?.owner?.privateSeller;
    const label = `cta::${_kebabCase(labelText)}`;

    const psxPixallData = {
        listingType: 'pvt',
        pageId: 'fyc_psx_vdp',
    };

    Pixall.sendClickEvent({
        eventSource: 'button',
        eventType: 'click',
        label,
        inventory,
        ...(isVDP(dataLayer) && { pixallData: { clickTypeToListingType: !isPrivateSeller } }),
        ...(isPrivateSeller && { ...psxPixallData }),
    }, dataLayer, option);

    return {};
}
